/**
 * @desc 调拨批次单上传pod文件
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationBatchUploadPodFileRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationBatch/uploadPodFile`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
